import { createContext, useEffect, useReducer } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
// GLOBAL CUSTOM COMPONENTS
import Loading from "app/components/MatxLoading";

const initialState = {
  user: null,
  isInitialized: false,
  isAuthenticated: false,
  message: null,
};

const isValidToken = (accessToken) => {
  if (!accessToken) return false;
  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT": {
      const { isAuthenticated, user } = action.payload;
      return { ...state, user, isAuthenticated, isInitialized: true };
    }
    case "LOGIN": {
      const { user, message } = action.payload;
      return { ...state, user, isAuthenticated: true, message };
    }
    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }
    case "REGISTER": {
      const { user } = action.payload;
      return { ...state, isAuthenticated: true, user };
    }
    default: {
      return state;
    }
  }
};

const AuthContext = createContext({
  ...initialState,
  method: "JWT",
  logout: null,
  login: async () => {},
  register: null,
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const login = async (email, password) => {
    try {
      const response = await fetch(
        "https://x53pa0z7va.execute-api.eu-west-1.amazonaws.com/portal/loginUser",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Login error:", errorData);
        throw new Error(errorData.message || "Login failed");
      }

      const jsonResponse = await response.json();
      const { data: loginData } = jsonResponse;
      const {
        message,
        token: accessToken,
        name,
        email: userEmail,
        phoneNumber,
        role,
      } = loginData;

      setSession(accessToken);

      dispatch({
        type: "LOGIN",
        payload: {
          user: {
            name,
            phoneNumber,
            email: userEmail,
            role: role || "SA",
          },
          message,
        },
      });
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  const register = async (firstName, email, password) => {
    const { data } = await axios.post("/api/auth/register", {
      firstName,
      email,
      password,
    });
    const { accessToken, user } = data;

    setSession(accessToken);
    dispatch({ type: "REGISTER", payload: { user } });
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: "LOGOUT" });
  };

  useEffect(() => {
    (async () => {
      try {
        const accessToken = window.localStorage.getItem("accessToken");

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          const decodedToken = jwtDecode(accessToken);
          const user = {
            id: decodedToken.id,
            email: decodedToken.email,
            role: decodedToken.role,
          };

          dispatch({
            type: "INIT",
            payload: { isAuthenticated: true, user },
          });
        } else {
          dispatch({
            type: "INIT",
            payload: { isAuthenticated: false, user: null },
          });
        }
      } catch (err) {
        dispatch({
          type: "INIT",
          payload: { isAuthenticated: false, user: null },
        });
      }
    })();
  }, []);

  if (!state.isInitialized) return <Loading />;

  return (
    <AuthContext.Provider
      value={{ ...state, method: "JWT", login, logout, register }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;



// import { createContext, useEffect, useReducer } from "react";
// import { jwtDecode } from "jwt-decode";
// import axios from "axios";
// // GLOBAL CUSTOM COMPONENTS
// import Loading from "app/components/MatxLoading";

// const initialState = {
//   user: null,
//   isInitialized: false,
//   isAuthenticated: false,
//   message: null,
// };

// const isValidToken = (accessToken) => {
//   if (!accessToken) return false;
//   const decodedToken = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decodedToken.exp > currentTime;
// };

// const setSession = (accessToken) => {
//   if (accessToken) {
//     localStorage.setItem("accessToken", accessToken);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//   } else {
//     localStorage.removeItem("accessToken");
//     delete axios.defaults.headers.common.Authorization;
//   }
// };

// const reducer = (state, action) => {
//   switch (action.type) {
//     case "INIT": {
//       const { isAuthenticated, user } = action.payload;
//       return { ...state, user, isAuthenticated, isInitialized: true };
//     }
//     case "LOGIN": {
//       const { user, message } = action.payload;
//       // console.log("Updating state with LOGIN:", { user, message });
//       return { ...state, user, isAuthenticated: true, message };
//     }
//     case "LOGOUT": {
//       return { ...state, isAuthenticated: false, user: null };
//     }
//     case "REGISTER": {
//       const { user } = action.payload;
//       return { ...state, isAuthenticated: true, user };
//     }
//     default: {
//       return state;
//     }
//   }
// };

// const AuthContext = createContext({
//   ...initialState,
//   method: "JWT",
//   logout: null,
//   login: async () => {},
//   register: null
// });

// export const AuthProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(reducer, initialState);

//   const login = async (email, password) => {
//     try {
//       // console.log("email:-", email);
//       // console.log("password:-", password);

//       const response = await fetch(
//         "https://x53pa0z7va.execute-api.eu-west-1.amazonaws.com/portal/loginUser",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ email, password }),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Login error:", errorData);
//         throw new Error(errorData.message || "Login failed");
//       }

//       const jsonResponse = await response.json();
//       // console.log("jsonResponse:-", jsonResponse);

//       // Destructure the nested user data from jsonResponse
//       const { data: loginData } = jsonResponse;
//       const { message, token: accessToken, name, email: userEmail, phoneNumber,role } = loginData;

//       // console.log("Login message:", message);

//       // Set the session using the access token
//       setSession(accessToken);

//       // Dispatch the LOGIN action with the user details and message
//       dispatch({ 
//         type: "LOGIN",
//         payload: {
//           user: {
//             name,
//             phoneNumber,
//             email: userEmail, // using email from the response
//             role: role|| "SA", // Default to "SA" as defined in your code
//           },
//           // token: accessToken, 
//           message, // Include the message from the API response
//         },
//       });
//     } catch (error) {
//       console.error("Login error:", error);
//       throw error; // Propagate the error for the UI to handle
//     }
//   };

//   const register = async (firstName, email, password) => {
//     const { data } = await axios.post("/api/auth/register", { firstName, email, password });
//     const { accessToken, user } = data;

//     setSession(accessToken);
//     dispatch({ type: "REGISTER", payload: { user } });
//   };

//   const logout = () => {
//     setSession(null);
//     dispatch({ type: "LOGOUT" });
//   };

//   useEffect(() => {
//     (async () => {
//       try {
//         const accessToken = window.localStorage.getItem("accessToken");

//         if (accessToken && isValidToken(accessToken)) {
//           setSession(accessToken);
//           const decodedToken = jwtDecode(accessToken);
//           const user = {
//             id: decodedToken.id,
//             email: decodedToken.email,
//             companyId: decodedToken.companyId,
//             role: decodedToken.role,
//           };

//           dispatch({
//             type: "INIT",
//             payload: { isAuthenticated: true, user },
//           });
//         } else {
//           dispatch({
//             type: "INIT",
//             payload: { isAuthenticated: false, user: null },
//           });
//         }
//       } catch (err) {
//         dispatch({
//           type: "INIT",
//           payload: { isAuthenticated: false, user: null },
//         });
//       }
//     })();
//   }, []);

//   if (!state.isInitialized) return <Loading />;

//   return (
//     <AuthContext.Provider value={{ ...state, method: "JWT", login, logout, register }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export default AuthContext;

